import React, { useState, useEffect } from "react";
import { ImCheckboxChecked } from "react-icons/im";

function AuditorForm({ master }) {
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [audited, setAudited] = useState(false); // nuevo estado
    const [showAlert, setShowAlert] = useState(false); // estado para mostrar la alerta

    const handleAudit = () => {
        const atLeastOneChecked = checkedItems.some(item => item);

        if (!atLeastOneChecked) {
            setShowAlert(true);
            setAudited(false);
            return;
        }

        setShowAlert(false);
        setAudited(true);
    };

    const handleTicket = () => {
        alert('Ticket');
    };

    const handleSelectAll = () => {
        const newState = !selectAll;
        setCheckedItems(checkedItems.map(() => newState));
        setSelectAll(newState);
    };

      const handleCheckboxChange = (index) => {
        const updatedChecks = [...checkedItems];
        updatedChecks[index] = !updatedChecks[index];
        setCheckedItems(updatedChecks);
    };

    useEffect(() => {
        const totalItems = master.subproducts?.length > 0 ? master.subproducts.length : 1;
        setCheckedItems(Array(totalItems).fill(false));
        setSelectAll(false);
        setAudited(false); // Reiniciamos en cada cambio de master
        setShowAlert(false);
    }, [master]);

    console.log(master.subproducts);

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-3">
                    <p><span className="fw-bold">Master:</span> {master.number} </p>
                </div>
                <div className="col-3">
                    <p><span className="fw-bold">Origen:</span> {master.number} </p>
                </div>
                <div className="col-3">
                    <p><span className="fw-bold">Destino:</span> {master.number} </p>
                </div>
                <div className="col-3">
                    <p><span className="fw-bold">Piezas:</span> {master.number} </p>
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <p><span className="fw-bold">Peso:</span> {master.number} </p>
                </div>
                <div className="col-3">
                    <p><span className="fw-bold">Volúmen:</span> {master.number} </p>
                </div>
                <div className="col-3">
                    <p><span className="fw-bold">Tipo de mercancía:</span> {master.merchandiseType} </p>
                </div>
            </div>
            <div className="row">
                <div className="col mt-4 d-flex justify-content-end">
                    <button className='btnn' onClick={handleSelectAll} > <ImCheckboxChecked /> Todos</button>
                </div>
            </div> 

            <table className="table table-striped mt-3">
                <thead className="text-center">
                    <tr>
                        {master.subproducts?.length > 0 && (
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>HBS</th>
                        )}
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha</th>
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Nombre Archivo</th>
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Volúmen</th>
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Tarima</th>
                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {master.subproducts?.length > 0 ? (
                        <>
                        <tr>
                            <td></td>
                            <td>{master.fecha}</td>
                            <td>Nombre de archivo</td>
                            <td>0.5</td>
                            <td>{master.weight}</td>
                            <td>Cubicada</td>
                            <td>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    checked={checkedItems[0] || false}
                                    onChange={() => handleCheckboxChange(0)}
                                />
                            </td>
                        </tr>
                        {master.subproducts.map((sub, index) => (
                        <tr key={index}>
                            <td>{sub.hbs}</td>
                            <td>{sub.fecha}</td>
                            <td>Nombre de archivo</td>
                            <td>{sub.volume}</td>
                            <td>{sub.peso}</td>
                            <td>Cubicada</td>
                            <td>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    checked={checkedItems[index] || false}
                                    onChange={() => handleCheckboxChange(index)}
                                />
                            </td>
                        </tr>
                        ))}
                        </>
                    ) : (
                        // Caso sin subproducts
                        <tr>
                            {/* Omitimos la columna HBS si no hay subproducts */}
                            <td>{master.fecha}</td>
                            <td>Nombre de Archivo</td>
                            <td>0.3</td>
                            <td>{master.weight}</td>
                            <td>Cubicada</td>
                            <td>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    checked={checkedItems[0] || false}
                                    onChange={() => handleCheckboxChange(0)}
                                />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {showAlert && (
                <div className="alert alert-danger mt-3" role="alert">
                    Debes seleccionar al menos una medición
                </div>
            )}
            {/* <div class="alert alert-success" role="alert">
                Valores aceptados, se cobra conforme los datos de la guía.
            </div> */}
            

            <div className="row">
                <div className="col mt-4 d-flex justify-content-end gap-3">
                    <button className='btnn' onClick={handleAudit} >Auditar</button>
                    {audited && (
                        <button className='btnn' onClick={handleTicket}>Ticket</button>
                    )}
                </div>
            </div> 
        </div>
    );
}

export default AuditorForm;